const productionGroup = [
  115, // ahaSlidesUser
  122,
  170,
  52674,
  160202,
  231255,
  313323,
  516865,
  558097,
  559948,
  597420,
  605801,
  611356,
  655902,
  756990,
  882651,
  891804,
  1019765,
  1090072,
  1107200,
  1109505,
  1111716,
  1216658,
  1301499,
  1312070,
  1322197,
  1325376,
  1358806,
  1364850,
  1450880,
  1472007,
  1511877,
  1561300,
  1584785,
  1679897,
  1755480,
  1818636,
  1851905,
  1873379,
  1918789,
  1956931,
  1970774,
  1991658,
  2007749,
  2018905,
  2018906,
  2033646,
  2043281,
  2043285,
  2056141,
  2073206,
  2073211,
  617, // frequencyHostQuizUser
  23333,
  45778,
  56614,
  77963,
  82051,
  87760,
  126449,
  145773,
  267064,
  284251,
  288615,
  430255,
  447324,
  528960,
  584782,
  590518,
  617320,
  635714,
  655697,
  910614,
  934062,
  1002493,
  1090044,
  1168293,
  1178008,
  1233752,
  1273766,
  1285949,
  1321458,
  1345148,
  1387276,
  1490910,
  1521645,
  23333, // eduUser
  27131,
  45778,
  56614,
  76641,
  82051,
  87760,
  267064,
  278077,
  284251,
  288615,
  430255,
  528960,
  541099,
  584782,
  590518,
  617320,
  630569,
  635714,
  655697,
  812522,
  900016,
  910614,
  1002493,
  1178008,
  1233752,
  1321458,
  1345148,
  1353845,
  1387276,
  1401769,
  1406751,
  1424701,
  1425407,
  1438861,
  1466240,
  1483520,
  1490910,
  1521645,
  522904, // funQuizUser
  1319451,
  435748,
  627163,
  1029877,
  1449213,
  50014,
  1456897,
  141332,
  1076514,
  1350362,
  1571888,
  1669368,
  730558,
  604183,
  331858,
  562524,
  1153284,
  188292,
  465336,
  1277991,
  1306512,
  703710,
  1440798,
  1647076,
  1037398,
  1127421,
  101110,
  552058,
  1337692,
  1333159,
  36776,
  38059,
  631398,
  96925,
  36689,
  1097163,
  1500876,
  70662,
  33902,
  1808926,
  1650615,
  798204,
  1523766,
  710443,
  1293916,
  1792230,
  27934,
  1529472,
  991895,
  1422622,
  1483358,
  652262,
  1723746,
  259947,
  409011,
  1388772,
  1411691,
  475960,
  396181,
  1103938,
  772494,
  1727349,
  941180,
  941339,
  1631585,
  978270,
  56284,
  541045,
  1371912,
  1240259,
  1154801,
  1176407,
  1257838,
  1086373,
  1393165,
  727742,
  1109846,
  1475512,
  1562621,
  1646833,
  1117428,
  1347715,
  503596,
  1538209,
  1101828,
  720834,
  869959,
  519482,
  1298559,
  363082,
  22211,
]

const localGroup = [
  1336,
  3555,
  3346,
]

export default {
  productionGroup,
  localGroup,
}
